export default __webpack_public_path__ + "static/dialogues-7699a742a16004529ec28f4c5789d056.png";